import { clsx } from 'clsx';
import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';

type Props = {
  content: React.ReactNode[][];
  fullWidth?: boolean;
  className?: string;
  labelOrientation?: 'vertical' | 'horizontal' | 'none';
};

export const AlignedInfo = ({
  content,
  fullWidth,
  className,
  labelOrientation = 'vertical',
}: Props) => {
  const finalClassName = clsx('wk-aligned-info', className, {
    'wk-aligned-info--full-width': fullWidth,
    'wk-aligned-info--vertical-label': labelOrientation === 'vertical',
    'wk-aligned-info--horizontal-label': labelOrientation === 'horizontal',
  });

  function handleColKey(singleContent: React.ReactNode) {
    if (typeof singleContent === 'object') {
      // eslint-disable-next-line
      // @ts-ignore: reusing key from JSX element
      return singleContent?.key;
    }

    return singleContent;
  }

  return (
    <>
      <table className={finalClassName}>
        <tbody>
          {content.map((row, index) => (
            <tr className="wk-aligned-info__row" key={index.toString()}>
              {row.map((singleContent) => (
                <td
                  className="wk-aligned-info__col"
                  key={handleColKey(singleContent)}
                >
                  {singleContent}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <style jsx>{`
        .wk-aligned-info--full-width {
          width: 100%;
        }
        .wk-aligned-info--horizontal-label tr:first-child td {
          color: ${Colors.midnightLighter};
        }
        .wk-aligned-info--horizontal-label td {
          width: 150px;
        }
        .wk-aligned-info--vertical-label td:first-child {
          min-width: 150px;
          padding-right: 24px;
          color: ${Colors.midnightLighter};
        }
        .wk-aligned-info__col {
          min-width: 100px;
          font-weight: 500;
          line-height: 20px;
          padding-bottom: 12px;
        }
      `}</style>
    </>
  );
};
